/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetResponseFeedbackRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetResponseFeedbackRequest$inboundSchema: z.ZodType<
  GetResponseFeedbackRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetResponseFeedbackRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetResponseFeedbackRequest$outboundSchema: z.ZodType<
  GetResponseFeedbackRequest$Outbound,
  z.ZodTypeDef,
  GetResponseFeedbackRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getResponseFeedbackRequestToJSON(
  getResponseFeedbackRequest: GetResponseFeedbackRequest,
): string {
  return JSON.stringify(
    GetResponseFeedbackRequest$outboundSchema.parse(getResponseFeedbackRequest),
  );
}
export function getResponseFeedbackRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetResponseFeedbackRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetResponseFeedbackRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetResponseFeedbackRequest' from JSON`,
  );
}
